/* istanbul ignore file */
import { nextTick } from 'vue';
import { storeToRefs } from 'pinia';
import { useSlideoutStore as slideoutLocal } from '@/stores/useSlideoutStore';
import { useSlideoutStore } from '@nuxt-common/atomic-ui/app/stores/useSlideoutStore';

export function useSlideout() {
  const store = slideoutLocal();
  const externalStore = useSlideoutStore();
  const { slideout } = storeToRefs(store);

  return {
    registerSlideout: (payload) => store.setSlideout(payload),
    toggleSlideout: async (id) => {
      await nextTick();
      externalStore.toggle(id);
    },
    closeSlideout: async (id) => {
      await nextTick();
      externalStore.close(id);
    },
    slideout,
  };
}
